<template>
  <div id="mobile-nav" :class="{active: openMenu}">
    <img id="mobileNavLogo" src="@/assets/icons/cubs-white.png" />
    <div class="mobileMenuBtn" @click="openMenu = !openMenu" :class="{active: openMenu}">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <b-nav class="mainMenu" :class="{active: openMenu}">
      <div class="mobile-links">
       

        <b-nav v-b-scrollspy>
          <div class="p-nav-links">
            <!-- <b-nav-item
              class="p-nav-link"
              href="#Landing"
              v-scroll-to="'#Landing'"
              @click="openMenu = !openMenu"
            >
              Home
            </b-nav-item>
            <b-nav-item
              class="p-nav-link" 
              href="#Form"
              v-scroll-to="'#Form'"
              @click="openMenu = !openMenu"
            >
              Select Your Prizes
            </b-nav-item> -->
            <b-nav-item
              class="p-nav-link"
            >
              <b-button @click="$bvModal.show('modal-rules'), openMenu = !openMenu">Sweepstakes Rules</b-button>
            </b-nav-item>
          </div>
        </b-nav>  
      </div>
    </b-nav>
  </div>
</template>

<script>
import { navData } from "@/data/navData";
import { TweenLite } from "gsap/dist/gsap";

export default {
  name: "PrimaryNav",
  watch: {
    openMenu: function(newMenu, oldMenu) {
      if (newMenu) {
        document.documentElement.style.overflow = "hidden";
      } else {
        document.documentElement.style.overflow = "auto";
      }
    }
  },
  data() {
    return {
      openMenu: false
    };
  },
  created() {
    window.addEventListener("scroll", this.scrollInit);
  },
  methods: {
    scrollInit() {
      if (document.documentElement.scrollTop > 0) {
        this.topNavActiveClass = "active";
      } else {
        this.topNavActiveClass = "";
      }
    },
    toggleMenu() {
      let menu = document.getElementById("mainMenuItems");

      if (menu.style.height === "0px" || menu.style.height === "") {
        TweenLite.to(menu, 0.5, {
          height: menu.scrollHeight
        });
      } else {
        TweenLite.to(menu, 0.5, {
          height: 0
        });
      }
    }
  },
  mounted() {
    let scrollpos = window.scrollY
    const header = document.getElementById("topNav")
    const header_height = header.offsetHeight

    const add_class_on_scroll = () => header.classList.add("fadeIn")
    const remove_class_on_scroll = () => header.classList.remove("fadeIn")

    window.addEventListener('scroll', function() { 
      scrollpos = window.scrollY;
      if (scrollpos >= header_height) {
        add_class_on_scroll()
      } else {
        remove_class_on_scroll()
      }
    })
  }
};
</script>

<style lang="scss" scoped>
#mobile-nav {
  height: 70px;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position-x: 65%;
  background-position-y: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: 22px;
  padding-left: 21px;
  transition: all 0.25s ease-in-out;
  @media (max-width: $xl) {
    padding-right: 6.2vw;
  }
  &.fadeIn {
    background-color: $dark-blue;
  }
  &.active {
    background-color: transparent;
  }
  /**Adjust this padding for mobile, remove and justify center */
  .mobile-links {
    position: relative;
    height: 100%;
    width: 100%;
    .nav {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 80%;
      .p-nav-links {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .p-nav-link {
          margin: 25px 0;
          a {
            font-family: 'mr-eaves-modern';
            font-weight: 700;
            font-style: normal;
            font-size: 29px;
            color: #fff;
            text-align: center;
            line-height: 24px;
          }
          button {
            font-family: 'mr-eaves-modern';
            font-weight: 700;
            font-style: normal;
            font-size: 29px;
            color: #fff;
            text-align: center;
            line-height: 24px;
            padding: 0;
            background-color: transparent;
            border: none;
            &:focus {
              outline: none;
              box-shadow: none;
            }
          }
        }
      }
    }
  }
  #mobileNavLogo {
    width: 54px;
  }
 
  .mainMenu {
    background-image: url("~@/assets/images/mobile-nav-bg.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    height: calc(100vh - 70px);
    width: 100%;
    position: fixed;
    top: 70px;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    background-color: $dark-blue;
    transition: all 0.25s ease-in-out;
    visibility: hidden;
    opacity: 0;
    &.active {
      visibility: visible;
      opacity: 1;
    }
  }
  .mobileMenuBtn {
    position: relative;
    top: 3px;
    height: 30px;
    width: 30px;
    transform: rotate(0deg);
    transition: 0.5s ease-in-out;
    cursor: pointer;
    z-index: 4 !important;
    span {
      display: block;
      position: absolute;
      height: 4px;
      width: 30px;
      background: #ffffff;
      border-radius: 4px;
      opacity: 1;
      left: 0;
      transform: rotate(0deg);
      transition: 0.25s ease-in-out;
      &:nth-child(1) {
        top: 0px;
      }
      &:nth-child(2) {
        top: 10px;
      }
      &:nth-child(3) {
        top: 20px;
      }
    }
    &.active {
      span {
        &:nth-child(1) {
          top: 10px;
          transform: rotate(135deg);
        }
        &:nth-child(2) {
          opacity: 0;
          left: -60px;
        }
        &:nth-child(3) {
          top: 10px;
          transform: rotate(-135deg);
        }
      }
    }
  }
}
</style>